export default __webpack_public_path__ + "bbff1bfe81b26b1e3905191578f04527.png";